import CustomHttpAction from '../cardActions/CustomHttpAction';
import { HttpAction, HttpHeader } from 'adaptivecards';

export default function parseHttpAction(json: any): HttpAction {
    const action = new CustomHttpAction(true /*preserveBody*/);
    action.method = 'POST';
    action.body = json.body;
    action.title = json.name;
    action.originalJsonPayload = json;

    if (json.headers && json.headers.length > 0) {
        action.headers = [];
        json.headers.forEach(header => {
            action.headers.push(new HttpHeader(header.name, header.value));
        });
    }

    action.url = json.target;
    action['@id'] = json['@id'];
    action.hideCardOnInvoke = json.hideCardOnInvoke;

    return action;
}
